import LogReport from './LogReport';
import DataReportMap from '../../../reporter/report/DataReportMap';
import { LogReporterMessage } from './interfaces';
import { ReporterMessage } from '../../../log';

interface OverflowBlock {
  count: number;
  first: number;
  last: number;
}

/**
 * This object is to store overflows from the PendingReport, so that we can tell
 * when there is more data that is being thrown away, and how much data is being
 * thrown away. If there is any overflows, this data then gets reformatted into
 * a log message that gets sent as part of the logs.
 */
export default class OverflowData {
  count: number;
  data: Record<string, OverflowBlock>;
  first: number;
  last: number;

  constructor() {
    this.count = 0;
    this.data = {};
    this.first = 0;
    this.last = 0;
  }

  toMessage(): string[] {
    return Object.entries(this.data).map(([name, block]) => {
      return `"${name}":${JSON.stringify(block)}`;
    });
  }

  report(
    log: DataReportMap<ReporterMessage, LogReport, LogReporterMessage>
  ): void {
    if (!this.count) {
      return;
    }
    const overflow = this.toLogReport();
    // NOTE: This could increase the number of logs above the maximum by one.
    // NOTE: that the name 'overflows' does not match the names that are
    // constructed by the naming for the logs, so there is no chance of
    // overwriting existing log data.
    log.data['overflows'] = overflow;
  }

  toLogReport(): LogReport {
    const { count, last, first } = this;
    const report = LogReport.create({
      data: { msg: this.toMessage(), ts: first },
      // This is sent as INFO even when the reporter is not set to send INFO
      // logs.
      level: 'INFO',
      type: 'OverflowData'
    });
    report.count = count;
    report.last = last;
    return report;
  }

  add(name: string): void {
    const last = Date.now();
    const data = this.data[name];
    this.last = last;
    if (!data) {
      this.count++;
      if (!this.first) {
        this.first = this.last;
      }
      this.data[name] = { last, first: last, count: 1 };
    } else {
      data.last = last;
      data.count += 1;
    }
  }
}
